import { on, off } from 'delegated-events'

const handleClickOutside = (e) => {
  const trigger = e.target.closest('[data-popover]')

  if (!trigger) {
    document.querySelectorAll('[data-popover]').forEach((x) => close(x))
  }
}

const open = (trigger) => {
  const panel = trigger.parentNode.querySelector(`#${trigger.getAttribute('aria-controls')}`)
  const root = trigger.closest('[data-popover-root]')

  trigger.setAttribute('aria-expanded', 'true')
  panel.classList.add('is-active')

  if (root) {
    root.classList.add('is-active')
  }
}

const close = (trigger) => {
  const panel = trigger.parentNode.querySelector(`#${trigger.getAttribute('aria-controls')}`)
  const root = trigger.closest('[data-popover-root]')

  trigger.setAttribute('aria-expanded', 'false')
  panel.classList.remove('is-active')

  if (root) {
    root.classList.remove('is-active')
  }
}

const handleToggle = (e) => {
  const trigger = e.target.closest('[data-popover]')

  Array.from(document.querySelectorAll('[data-popover]'))
    .filter((x) => x !== trigger)
    .forEach((x) => close(x))

  if (trigger.getAttribute('aria-expanded') === 'false') {
    open(trigger)
  } else {
    close(trigger)
  }
}

export default {
  init: () => {
    const clickArgs = ['click', '[data-popover]', handleToggle]
    const keyArgs = ['keyup', '[data-popover]', handleToggle]

    off(...clickArgs)
    off(...keyArgs)

    on(...clickArgs)
    on(...keyArgs)

    window.removeEventListener('click', handleClickOutside)
    window.addEventListener('click', handleClickOutside)
  },
}
